import * as React from 'react'

function CaretUp(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.5 12.38"
      {...props}
    >
      <path
        d="M19.81 12.07a1 1 0 001.43-1.34L11.46.3a1 1 0 00-1.42 0L.26 10.73a1 1 0 000 1.38 1 1 0 001.38 0l9.06-9.67z"
        fill="#414141"
      />
    </svg>
  )
}

export default CaretUp
